import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { LoadingComponent } from 'src/app/utils/loading/loading.component';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
    selector: 'app-sso-redirect',
    standalone: true,
    imports: [LoadingComponent],
    templateUrl: './sso-redirect.component.html'
})
export class SsoRedirectComponent implements OnInit {

    constructor(
        private readonly configurationService: ConfigurationService,
        private readonly utilsService: UtilsService,
        private readonly router: Router
    ) { }

    async ngOnInit() {
        await this.configurationService.setInitialConfgiguration();
        this.configurationService.setStyle();
        const defaultHome = await this.utilsService.getCurrentUserHomePath();
        await this.router.navigate([defaultHome]);
    }
}
